<template>
  <div class="detail_layout">
    <div class="detail_body">
      <div class="detail_body_top">
        <span>{{ title }}</span>
      </div>
      <div class="detail_body_content">
        <div>
          {{ content }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
        title:'这是一个标题',
        content:'这是一条详情内容这是一条详情内容这是一条详情内容这是一条详情内容这是一条详情内容这是一条详情内容这是一条详情内容'
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {},
  },
};
</script>
<style scoped lang="less">
.detail_layout {
  width: 100%;
  min-height: 100vh;
}
.detail_body {
  width: 100%;
  height: 100%;
  overflow-y: auto;
 
  .detail_body_top{
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    padding: 16px;
    color: #333;
  }
  .detail_body_content{
    margin: 16px;
  }
}
</style>
